<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="p-d-flex p-jc-center title">
      <div>
        <label>地方創生SDGs官民連携プラットフォーム</label><br />
        <label class="p-d-flex p-jc-center title-name">分科会</label>
      </div>
    </div>
    <!-- 本文 -->
    <div class="p-d-flex p-jc-center">
      <span>＜分科会とは＞<br />
      <a class="title-text"
        href="https://future-city.go.jp/platform/about/#bunkakai"
        target="_blank">「地方創生SDGs」のさまざまなテーマについて、取組や研究の同志を募り活動できる場所
      </a>
      、それが分科会です。<br /><br />
      &nbsp;&nbsp;&nbsp;&nbsp;以下で設置中の分科会では、同じテーマに関心を寄せる団体同士で共に活動し、知見を共有しています。<br />
      &nbsp;&nbsp;各会の取組・活動内容につきましては、各会のタイルから詳細画面を通じてご確認いただけます。<br />
      &nbsp;&nbsp;興味・関心のある会が見つかりましたら、ぜひご参加ください。<br />
      &nbsp;&nbsp;分科会に参加する場合は<ng-Tamplate *ngIf="isLogin">ログイン</ng-Tamplate><ng-Tamplate *ngIf="!isLogin"><a [routerLink]="" (click)="moveB301()">ログイン</a></ng-Tamplate>していただき、各会の詳細画面内に表示される「参加登録」ボタンからご参加いただけます。<br />
      &nbsp;&nbsp;&nbsp;&nbsp;また、会員は自らの提案により、新たに分科会を設置することができます。マイページ内「分科会設置登録・管理」ボタンよりお手続きください。<br /><br />
      ※各分科会の活動内容・イベント等について、当プラットフォーム及び運営事務局（内閣府）が管理・保証するものではありません。</span>
    </div>

    <!-- メインコンテンツ 年度別 -->
    <div class="years">
      <p-tabView>
        <ng-container
          *ngFor="let subcommitteeData of sortDataList(subcommitteeDataList, 'year', true, 'number'); let first = first;">
          <p-tabPanel [header]="subcommitteeData.year" [selected]="first">
            <!-- 当年度 分科会一覧表示 -->
            <div class="subcommitteeList" *ngIf="subcommitteeData.year == currentYear">
              <div *ngIf="noticeList?.length > 0">
                <!-- サブタイトル -->
                <div class="sub-title">
                  <h2>分科会のイベント・お知らせ</h2>
                </div>
                <div class="notice-contents">
                  <p-table [value]="noticeList" styleClass="p-datatable-striped memberEventData"
                    emptyMessage="データが存在しません" [autoLayout]="true" [scrollable]="true" scrollHeight="173px"
                    responsiveLayout="scroll">
                    <ng-template pTemplate="body" let-notice>
                      <tr class="update-data" (click)="moveE102(notice?.member_event_id)">
                        <!-- 掲載日付 -->
                        <td class="date">{{ notice?.date }}</td>
                        <!-- イベント区分 -->
                        <td class="event_kbn">
                          <!-- イベント区分が2の場合 -->
                          <p-tag value="お知らせ" styleClass="information-tag" *ngIf="2 == notice?.event_kbn.id"></p-tag>
                          <!-- イベント区分が4の場合 -->
                          <p-tag value="イベント" styleClass="event-tag" *ngIf="4 == notice?.event_kbn.id"></p-tag>
                        </td>
                        <!-- タイトル・分科会名 -->
                        <td class="title">{{ notice?.title + " : " + notice?.theme }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
              <div *ngIf="organizerSubcommitteeList?.length > 0">
                <!-- サブタイトル -->
                <div class="sub-title">
                  <h2>参加中の分科会</h2>
                </div>
                <!-- リスト表示 -->
                <p-dataView [value]="organizerSubcommitteeList" emptyMessage="データが存在しません" layout="grid">
                  <ng-template let-organizerSubcommittee pTemplate="gridItem">
                    <div class="p-col-12 p-md-3">
                      <!-- 設置中ラベル-->
                      <div class="p-d-flex p-jc-center installation">
                        <div class="p-as-center">設置中</div>
                      </div>
                      <div class="item-area item" (click)="moveE202(organizerSubcommittee.subcommittee.id)">
                        <!-- 分科会情報 -->
                        <div class="theme">
                          {{ organizerSubcommittee.subcommittee.theme }}
                        </div>
                        <div class="organization_name">
                          {{ organizerSubcommittee.organization_name }}
                        </div>
                        <div class="create_datetime">
                          {{ convCreatedate(organizerSubcommittee.subcommittee.create_datetime) }}
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-dataView>
              </div>
              <!-- サブタイトル -->
              <div class="sub-title">
                <h2>分科会一覧</h2>
              </div>
              <!-- リスト表示 -->
              <p-dataView [value]="subcommitteeData" emptyMessage="現在設置されている分科会はありません" layout="grid">
                <ng-template let-subcommittee pTemplate="gridItem">
                  <div class="p-col-12 p-md-3">
                    <!-- 設置中ラベル-->
                    <div class="p-d-flex p-jc-center installation">
                      <div class="p-as-center">設置中</div>
                    </div>
                    <div class="item-area item" (click)="moveE202(subcommittee.subcommittee_id)">
                      <!-- 分科会情報 -->
                      <div class="theme">
                        {{ subcommittee.theme }}
                      </div>
                      <div class="organization_name">
                        {{ subcommittee.organization_name }}
                      </div>
                      <div class="create_datetime">
                        {{ convCreatedate(subcommittee.create_datetime) }}
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-dataView>
            </div>
            <!-- 過去年度(2022年まで) 分科会一覧表示 -->
            <div class="subcommitteeList"
            *ngIf="subcommitteeData.year != currentYear && subcommitteeData.year != '2021-2018'">
            <!-- サブタイトル -->
              <div class="sub-title">
                <h2>分科会報告書</h2>
              </div>

              <div class="information-margin-height"></div>
              <div>
                <a href="{{'https://future-city.go.jp/data/pdf/platform/' + subcommitteeData.year + '_meeting.pdf'}}"
                   class="PDF-button" target="_blank">
                  {{subcommitteeData.year + '年度 全分科会の概要及び活動報告書'}}
                </a>
              </div>
              <!-- サブタイトル -->
              <div class="sub-title">
                <h2>分科会一覧</h2>
              </div>
              <!-- リスト表示 -->
              <p-dataView [value]="subcommitteeData" emptyMessage="現在設置されている分科会はありません" layout="grid">
                <ng-template let-subcommittee pTemplate="gridItem">
                  <div class="p-col-12 p-md-3">
                    <div class="item-area item" (click)="moveE202(subcommittee.subcommittee_id)">
                      <!-- 分科会情報 -->
                      <div class="theme">
                        {{ subcommittee.theme }}
                      </div>
                      <div class="organization_name">
                        {{ subcommittee.organization_name }}
                      </div>
                      <div class="create_datetime">
                        {{ convCreatedate(subcommittee.create_datetime) }}
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-dataView>
            </div>
            <!-- 2018-2021年度 分科会一覧表示 -->
            <div class="subcommitteeList" *ngIf="subcommitteeData.year == '2021-2018'">
              <!-- サブタイトル -->
              <div class="sub-title">
                <h2>分科会報告書</h2>
              </div>
              <div class="PDF-form">
                <div>
                  <div class="information-margin-height"></div>
                  <div>
                    <a href="https://future-city.go.jp/data/pdf/platform/2021_meeting.pdf" class="PDF-button"
                      target="_blank">
                      2021年度 全分科会の概要及び活動報告書
                    </a>
                  </div>
                  <div class="information-margin-height"></div>
                  <div>
                    <a href="https://future-city.go.jp/data/pdf/platform/2020_meeting.pdf" class="PDF-button"
                      target="_blank">
                      2020年度 全分科会の概要及び活動報告書
                    </a>
                  </div>
                  <div class="information-margin-height"></div>
                  <div>
                    <a href="https://future-city.go.jp/data/pdf/platform/2018_2019_meeting.pdf" class="PDF-button"
                      target="_blank">
                      2018-2019年度 全分科会の概要及び活動報告書
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </p-tabPanel>
        </ng-container>
      </p-tabView>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
